(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    const activateFeaturedTab = (tab) => {
      const section = tab.closest('[id^="collection-"]');
      if (!section) return;

      const index = tab.dataset.vhTabIndex;

      section.querySelectorAll('[data-vh-featured-tab]').forEach((item) => {
        item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
      });

      section.querySelectorAll('[data-vh-featured-panel]').forEach((panel) => {
        const isActive = panel.dataset.vhTabIndex === index;
        panel.toggleAttribute('hidden', !isActive);

        if (isActive) {
          panel.querySelector('slider-component')?.resetPages?.();
        }
      });
    };

    const bindFeaturedCollectionTabs = (root = document) => {
      root.querySelectorAll('[data-vh-featured-tab]').forEach((tab) => {
        if (tab.dataset.vhFeaturedTabBound === 'true') return;
        tab.dataset.vhFeaturedTabBound = 'true';

        tab.addEventListener('click', () => activateFeaturedTab(tab));

        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

          const tabs = Array.from(tab.closest('[role="tablist"]')?.querySelectorAll('[data-vh-featured-tab]') || []);
          const currentIndex = tabs.indexOf(tab);
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTab = tabs[(currentIndex + direction + tabs.length) % tabs.length];

          if (nextTab) {
            event.preventDefault();
            nextTab.focus();
            activateFeaturedTab(nextTab);
          }
        });

        tab.addEventListener('pointermove', (event) => {
          if (!finePointer.matches || reduceMotion.matches) return;

          const rect = tab.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - 0.5) * 8;
          const y = ((event.clientY - rect.top) / rect.height - 0.5) * 5;

          tab.style.setProperty('--vh-tab-x', `${x}px`);
          tab.style.setProperty('--vh-tab-y', `${y}px`);
        });

        tab.addEventListener('pointerleave', () => {
          tab.style.removeProperty('--vh-tab-x');
          tab.style.removeProperty('--vh-tab-y');
        });

        tab.addEventListener('blur', () => {
          tab.style.removeProperty('--vh-tab-x');
          tab.style.removeProperty('--vh-tab-y');
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindFeaturedCollectionTabs());
    } else {
      bindFeaturedCollectionTabs();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindFeaturedCollectionTabs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // O CSS do drawer/menu é carregado de forma diferida (media="print").
      // Antes dele aplicar, o #menu-drawer fica em fluxo e infla .section-header,
      // fazendo --header-height capturar um valor gigante (quebra o sticky da
      // mídia da PDP). Recalcular após o load — quando o CSS já posicionou o
      // drawer como absolute — garante a altura real do header.
      window.addEventListener('load', this.setHeaderHeight.bind(this));

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // Nunca esconder o header enquanto um drawer/modal está aberto (menu,
      // carrinho, busca) — o body recebe alguma classe overflow-hidden* nesses
      // casos. Esconder aqui deixaria o header (e o drawer ancorado nele) fora
      // da tela e a página travada. Espelha o lock de scroll do tema.
      if (document.body.className.indexOf('overflow-hidden') !== -1) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  class ImageBannerSlideshowMotion {
    constructor(component) {
      this.component = component;
      this.slider = component.querySelector('[id^="Slider-"]');
      this.duration = 900;

      if (!this.slider || component.dataset.motionEnhanced === 'true') return;

      component.dataset.motionEnhanced = 'true';
      component.setSlidePosition = this.setSlidePosition.bind(this);
    }

    easeInOutCubic(progress) {
      return progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    }

    setSlidePosition(position) {
      if (this.component.setPositionTimeout) clearTimeout(this.component.setPositionTimeout);
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);

      this.component.setPositionTimeout = setTimeout(() => {
        const start = this.slider.scrollLeft;
        const distance = position - start;
        const startTime = performance.now();

        const animate = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(elapsed / this.duration, 1);
          this.slider.scrollLeft = start + distance * this.easeInOutCubic(progress);

          if (progress < 1) {
            this.animationFrame = requestAnimationFrame(animate);
          }
        };

        this.animationFrame = requestAnimationFrame(animate);
      }, this.component.announcerBarAnimationDelay || 0);
    }
  }

  customElements.whenDefined('slideshow-component').then(() => {
    document.querySelectorAll('.image-banner-slideshow').forEach((component) => {
      new ImageBannerSlideshowMotion(component);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
